import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { readJson } from "./adminApi";

export const useGuidesInfo = (authFetch, enabled) => {
  const [link, setLink] = useState(null);
  const [guides, setGuides] = useState([]);
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    if (!enabled) return;
    try {
      const [l, g] = await Promise.all([authFetch("/admin/guide-reg/link"), authFetch("/admin/guide-reg")]);
      if (l.ok) setLink(await l.json());
      if (g.ok) setGuides(await g.json());
    } catch (err) {
      console.warn("guides info load failed", err);
    }
  }, [authFetch, enabled]);

  useEffect(() => { load(); }, [load]);

  const createLink = async () => {
    if (link?.token && !window.confirm("Create a new link? The old link will stop working.")) return;
    setBusy(true);
    try {
      const res = await authFetch("/admin/guide-reg/link", { method: "POST" });
      const data = await readJson(res);
      if (!res.ok) throw new Error(data?.detail || "Failed");
      setLink((l) => ({ ...(l || {}), ...data }));
      toast.success("Guides Information link created");
    } catch (err) {
      toast.error(err.message || "Could not create link");
    } finally {
      setBusy(false);
    }
  };

  const toggleLink = async (enabledFlag) => {
    try {
      const res = await authFetch("/admin/guide-reg/link", { method: "PUT", body: JSON.stringify({ enabled: enabledFlag }) });
      const data = await readJson(res);
      if (!res.ok) throw new Error(data?.detail || "Failed");
      setLink((l) => ({ ...(l || {}), ...data }));
      toast.success(enabledFlag ? "Link is open" : "Link closed");
    } catch (err) {
      toast.error(err.message || "Could not update link");
    }
  };

  const remove = async (g) => {
    if (!window.confirm(`Remove ${g.name} from Guides?`)) return;
    try {
      const res = await authFetch(`/admin/guide-reg/${g.id}`, { method: "DELETE" });
      if (!res.ok) throw new Error("Failed");
      setGuides((rows) => rows.filter((r) => r.id !== g.id));
      toast.success("Guide removed");
    } catch (err) {
      toast.error(err.message || "Could not remove");
    }
  };

  const add = async (form) => {
    const res = await authFetch("/admin/guide-reg", { method: "POST", body: JSON.stringify(form) });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(typeof data?.detail === "string" ? data.detail : "Could not add guide");
    await load();
    return data;
  };

  return { link, guides, busy, createLink, toggleLink, remove, add, reload: load };
};
